import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

const BreakWordTypography = styled(Typography)`
  word-wrap: break-word;
  word-break: break-all;
`

export default BreakWordTypography
